import {
  RFXRequestCoManagers,
  RFXRequestDocuments,
  RFXRequestReview,
  RFXRequestState,
  RFXRequestSuppliers,
  TrackingInformation
} from './RFXRequestForm';

export enum RFIType {
  RFI = 'RFI',
  MassCommunication = 'MassCommunication'
}

export function convertStringToRFIType(rifTypeString: string): RFIType {
  return RFIType[rifTypeString as keyof typeof RFIType];
}

export interface RFIRequestInformation {
  fullRfxId: string;
  parentRfxId?: string; // Used for clone
  rfxName: string;
  rfxType: string;
  rfiType: RFIType;
  buyer: string;
  regions: string[];
  sites: string[];
  businessId: string | null;
  beginDate: string;
  beginTime: string;
  dueDate: string; // Required answer date
  dueTime: string;
  categories: string[];
  subCategories?: string[];
  project: string;
  overview: string;
  processDetails: string;
  approvalLink?: string;
  workflow: string;
}

export interface RFICorrespondence {
  subject: string;
  // Rich text of the body
  body: string;
  // Pure text of the body
  bodyText: string;
}

export interface RFIRequestForm {
  state: RFXRequestState;
  rfxRequestVersion: number;
  generalInformation: RFIRequestInformation;
  correspondence: RFICorrespondence;
  suppliers: RFXRequestSuppliers;
  'co-managers': RFXRequestCoManagers;
  documents: RFXRequestDocuments;
  review: RFXRequestReview;
  trackingInformation: TrackingInformation;
}
